import React from 'react';
import axiosUrl from '../../../axios/url';



export default function SurveyModal(param) {

    const [surveyList, setSurveyList] = React.useState('');       
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [text, setText] = React.useState('');



    React.useEffect(() => {
        if(param.surveyList !== []) {
            setSurveyList(param.surveyList);
        }
    }, [param.surveyList])

    function surveyNext() {
        setCurrentIndex(currentIndex+1);
    }

    function surveyPre() {
        setCurrentIndex(currentIndex-1);
    }

    function surveyModalClose() {
        param.callbackSurveySendData();
    }

    function radioCheck(number) {
        console.log(number);
    }

    function checkBox(number) {
        console.log(number);
    }

    function textChange(value) {
        setText(value);
    }

    function submit() {
        console.log("submit");
    }

    return(
        <div className="modal fade" id="surveyModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl  modal-dialog-centered">
                <div className="modal-content">
                
                    <div className="modal-header">
                        <h4 className="modal-title">설문 미리보기</h4>
                        <button type="button" className="close" data-dismiss="modal" onClick={surveyModalClose}>&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <div className="card">
                            <div className="card-body">
                                {
                                    surveyList[currentIndex] !== undefined &&
                                    <div>
                                        <h3>{currentIndex + 1}. {surveyList[currentIndex].question}</h3>
                                        <div className="ml-2 form-group">
                                            {
                                                surveyList[currentIndex].answerType === "TEXT" ?(
                                                    <textarea className="form-control" rows="6" placeholder="작성해주세요" onChange={(e) => textChange(e.target.value)} value={text}></textarea>
                                                )
                                                :(
                                                    <div>
                                                        {surveyList[currentIndex].items.map((item, i) => (
                                                            <div key={i}>
                                                                {
                                                                    surveyList[currentIndex].selectionType === "SINGLE" ?(
                                                                        <div className="form-check">
                                                                            <input className="form-check-input" type="radio" name="radio" onClick={radioCheck(i)}/><label className="form-check-label">{i+1}. {item.body}</label>
                                                                        </div>
                                                                    ) :(
                                                                        <div className="form-check">
                                                                            <input className="form-check-input" type="checkbox" onClick={checkBox(i)}/><label className="form-check-label">{i+1}. {item.body}</label>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                }
                                  
                            </div>
                            <div>
                                <div className="card-footer clearfix">
                                    {
                                        // 첫 페이지 이전 버튼 안보이게
                                        currentIndex == 0 ?(
                                            <div></div>
                                        ) :(
                                            <button className="btn btn-primary float-left" onClick={surveyPre}>이전</button>
                                        )
                                    }
                                    {
                                        // 마지막 페이지 다음버튼 안보이게
                                        currentIndex + 1 == surveyList.length ?(
                                            <button className="btn btn-primary float-right" onClick={submit}>제출</button>
                                        ) : (
                                            <button className="btn btn-primary float-right" onClick={surveyNext}>다음</button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}